import { Directive, HostListener, Renderer2 } from '@angular/core';

/**
 * 限制只能輸入數字和連字號的指令，最多10字元
 */
@Directive({
  selector: '[appCompanyCodeOnly]',
  standalone: true,
})
export class CompanyCodeOnlyDirective {
  constructor(private renderer: Renderer2) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let sanitized = input.value.replace(/[^A-Za-z0-9-]/g, ''); // 改成這行,允許英文大小寫、數字和連字號
    
    // 限制最多10字元
    if (sanitized.length > 10) {
      sanitized = sanitized.slice(0, 10);
    }
    
    if (input.value !== sanitized) {
      this.renderer.setProperty(input, 'value', sanitized);
      
      // 確保 FormControl 同步更新,但不觸發新的 input 事件
      const ngControl = (input as any).ngControl;
      if (ngControl && ngControl.control) {
        ngControl.control.setValue(sanitized, { emitEvent: false });
        ngControl.control.updateValueAndValidity();
      }
    }
  }
}
